import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { Body, BodyContent, BodyHeading } from "@thrivetribe/mvf.ui.organisms.body";
import React, { ReactNode } from "react";
import classnames from "classnames";
import { CloseQuoteIcon, OpenQuoteIcon } from "@thrivetribe/mvf.assets.icons.quote-icons";

type OnboardingPageBodyWrapperProps = {
    image?: string;
    title?: string;
    quote?: string;
    authorName?: string;
    authorRole?: string;
    heading?: string;
    children: ReactNode;
    hideSubnav?: boolean;
    buttonText?: string;
    onBackClick?: () => void;
    onButtonClick?: () => void;
}

export const OnboardingPageBodyWrapper = (props: OnboardingPageBodyWrapperProps) => {
    const {
        image,
        children,
        title,
        quote,
        authorName,
        authorRole,
        heading,
        hideSubnav,
        onBackClick,
        onButtonClick,
        buttonText = "Continue",
    } = props;
    return (
        <Body className={classnames("onboarding-page__body", { "onboarding-page__body--no-subnav": hideSubnav })}>
            {!hideSubnav &&
                <BodyHeading slim>
                    <div className="onboarding-page__body--subnav">
                        <Button variant="text" onClick={onBackClick}>
                            <ButtonArrow /> <span>Back</span>
                        </Button>
                        <h3>{title}</h3>
                    </div>
                </BodyHeading>
            }
            <BodyContent>
                <div className={classnames("onboarding-page__body--container", { "onboarding-page__body--no-image": !image, "onboarding-page__body--quote-screen": quote })}>
                    <div className="onboarding-page__body--left-panel">
                        <div className="onboarding-page__body--image" style={{ backgroundImage: `url(${image})` }}>

                            {quote &&
                                <div className="onboarding-page__quote">
                                    <div className="onboarding-page__quote--block">
                                        <span className="onboarding-page__quote--open">
                                            <OpenQuoteIcon />
                                        </span>
                                        <h2 className="onboarding-page__quote--text">{quote}
                                            <span className="onboarding-page__quote--close">
                                                <CloseQuoteIcon />
                                            </span>
                                        </h2>
                                        <p className="onboarding-page__quote--author">
                                            <span className="onboarding-page__quote--authorname">{authorName}, </span>
                                            {authorRole}
                                        </p>
                                    </div>
                                </div>
                            }
                            {quote && <h1 className="onboarding-page__quote--heading">{heading}</h1>}
                            {quote && <div className="onboarding-page__quote--gradient"></div>}
                        </div>

                        {quote && buttonText &&
                            <div className="onboarding-page__quote--footer">
                                <Button variant="primary" color="primary" onClick={onButtonClick}>
                                    {buttonText}
                                    <ButtonArrow />
                                </Button>
                            </div>}
                    </div>
                    <div className="onboarding-page__body--right-panel">
                        <div className="onboarding-page__body--content-container">
                            {children}
                        </div>
                    </div>
                </div>
            </BodyContent>
        </Body>
    );
};